import Dialog from "@mui/material/Dialog";
import Cookies from "js-cookie";
import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import ACTIONS, {
  fetchAspPotentialProviders,
  fetchCherryPotentialProviders,
} from "../../redux/action.js";
import axios from "../../shared/axios/axiosProxy.js";
import KnetPlusForm from "../../shared/components/knetPlusForm/knetPlus.jsx";
import VacationNotice from "../../shared/components/vacationNotice/VacationNotice.jsx";
import i18n from "../../utils/i18n.js";
import { pushFlowContextToDataLayer } from "../utils/dataLayerFlowContext";
import { ensureSearchExists } from "../utils/ensureSearchExists";
import {
  mergeUtmIntoPayload,
  prepareAspPayload,
  resolveUtmParams,
} from "../utils/utmBootstrap";
import Monitors from "../searchFlowVersionB/components/monitors/monitors.jsx";
import SearchFlowHeader from "../searchFlowVersionB/components/searchFlowHeader/SearchFlowHeader.jsx";
import GeneralError from "../searchFlowVersionB/steps/common/GeneralError.jsx";
import SearchFlowFooterShell from "../searchFlowVersionB/components/searchFlowFooter/SearchFlowFooterShell.jsx";
import { evIndustryHasForeignTradeStep } from "../searchFlowVersionB/steps/ev/EvForeignTrade.jsx";
import { persistIndustryWithFinancialDefaults } from "../searchFlowVersionB/utils/persistIndustryWithFinancialDefaults.js";
import classes from "../searchFlowVersionB/searchFlow.module.scss";
import {
  CompanyType,
  Industry,
  RegContactForm,
  TaxconForm,
} from "./oldSteps/index.js";
import RegActivityDescription from "./steps/RegActivityDescription.jsx";
import RegCompanyType from "./steps/RegCompanyType.jsx";
import RegContactPage from "./steps/RegContactPage.jsx";
import RegForeignTrade from "./steps/RegForeignTrade.jsx";
import RegIndustryActivity, {
  regIndustryHasActivityContent,
} from "./steps/RegIndustryActivity.jsx";
import RegIndustrySelect from "./steps/RegIndustrySelect.jsx";
import RegSuccessScreen from "./steps/RegSuccessScreen.jsx";
import RegTaxForm from "./steps/RegTaxForm.jsx";
import { computeRegFlowProgressValue, getRegFlowProgress } from "./utils/regFlowProgress.js";
import { getRegStepFooterNav } from "./utils/regStepFooterNav.js";
import { createRegFlowAnalytics } from "./analytics/regFlowAnalytics.js";
import { normalizeEntryFlowSlug } from "./analytics/regFlowStepRegistry.js";

const USE_WIREFRAME_ROUTE = true;

const ENABLE_REG_FLOW_MONITORS = false;

const WIREFRAME_STEPS = [
  {
    component: RegIndustrySelect,
    extraProps: (self) => ({
      selectedIndustry: self.props.company_store?.industry || "",
      industryInput: self.props.company_store?.industryinput || "",
      setIndustrySelection: self.setIndustrySelection,
      setIndustryInput: self.setIndustryInput,
    }),
  },
  { component: RegIndustryActivity },
  {
    component: RegCompanyType,
    extraProps: (self) => ({
      regCompanyTypeSelection: self.state.regCompanyTypeSelection,
      setRegCompanyTypeSelection: self.setRegCompanyTypeSelection,
      onRegCompanyTypeBack: self.handleRegCompanyTypeBack,
      onRegCompanyTypeNext: self.handleRegCompanyTypeNext,
    }),
  },
  { component: RegActivityDescription },
  {
    component: RegTaxForm,
    extraProps: (self) => ({
      onInteractedChange: self.handleRegTaxFormInteractedChange,
      initialInteracted: self.state.regTaxFormInteracted,
    }),
  },
  { component: RegForeignTrade },
  {
    component: RegContactPage,
    extraProps: (self) => ({
      createAspRequest: self.createAspRequest,
      onRequestError: self.handleContactPageRequestError,
    }),
  },
  { component: RegSuccessScreen },
  { component: GeneralError },
];

const REG_FLOW_STEPS = [
  { component: CompanyType },
  { component: Industry },
  { component: TaxconForm },
  { component: RegContactForm },
];

const STEPS = USE_WIREFRAME_ROUTE ? WIREFRAME_STEPS : REG_FLOW_STEPS;

// Helper: calculate distance between two step components within STEPS
const getStepIncrement = (fromComponent, toComponent) => {
  const fromIndex = STEPS.findIndex((s) => s.component === fromComponent);
  const toIndex = STEPS.findIndex((s) => s.component === toComponent);
  return fromIndex >= 0 && toIndex >= 0 ? toIndex - fromIndex : 1;
};

const mapStateToProps = (state) => ({
  store: state,
  loading: state.loading,
  company_store: state.company_store,
  match_score_weights: state.match_score_weights,
  potential_providers: state.company_store.potential_providers,
});
const mapDispatchToProps = (dispatch) => ({
  addCompanyInfo: (item) => dispatch(ACTIONS.addCompanyInfo(item)),
  fetchAspPotentialProviders: (companyData, msWeights) =>
    dispatch(fetchAspPotentialProviders(companyData, msWeights)),
  fetchCherryPotentialProviders: (companyData, msWeights) =>
    dispatch(fetchCherryPotentialProviders(companyData, msWeights)),
});
class RegFlowVersionB extends React.Component {
  analyticsSessionStarted = false;
  flowCompleteTracked = false;
  flowAnalytics = null;

  constructor(props) {
    super(props);
    // "companytype" = arrived from CommonCompanyType's ambiguous "other" pick, so
    // RegCompanyType (reg/vaf/kftreg) still needs asking; default "routing" = arrived
    // already knowing it's reg (NewCompanyType, or a direct landing-page visit), so
    // RegCompanyType is skipped. Mirrors searchFlowVersionB's own regEntrySource.
    const urlParams = new URLSearchParams(window.location.search);
    this.state = {
      activeStep: 0,
      reqID: "",
      cherryID: "",
      searchID: "",
      completedSteps: 0,
      kNetPlusSent: false,
      helpForm: false,
      stepData: `1 - ${new Date().toLocaleTimeString(
        i18n.t("general.countryformat"),
        {
          hour12: false,
        },
      )}`,
      viewedProviders: [],
      utmzz: Cookies.get("__utmzz") || null,
      vacatiOn: false,
      bookkeepie_id: Cookies.get("bookkeepie_id") || null,
      utm_source: "",
      utm_medium: "",
      utm_campaign: "",
      utm_content: "",
      utm_term: "",
      gclid: "",
      dclid: "",
      regEntrySource: urlParams.get("regEntry") === "companytype" ? "companytype" : "routing",
      // Only show a Back button on RegIndustrySelect when we know where "back" leads —
      // i.e. the visitor was routed here from searchFlowVersionB's NewCompanyType step.
      // A direct landing (webflow link, A/B roll on /company/request/reg) has nowhere
      // sensible to go back to, so the button stays hidden there instead of dropping
      // the user at the flow start.
      cameFromNewCompanyType: urlParams.get("entry") === "newCompanyType",
      regCompanyTypeSelection: "",
      regTaxFormInteracted: false,
      regProgressValue: null,
      regProgressStep: null,
    };
  }

  dataLayerUpdate(stepData, event) {
    window.dataLayer.push({
      event: event,
      step: stepData,
      event_category: "regflow",
    });
  }

  bkIdDataLayerUpdate(stepData, event) {
    window.dataLayer.push({
      event: event,
      bookkeepie_id: stepData,
      event_category: "regflow",
    });
  }

  dataLayerVersionUpdate() {
    pushFlowContextToDataLayer({
      version: "B",
      flow: "regflow",
      company_store: this.props.company_store,
    });
  }

  componentDidMount() {
    let bkID = Cookies.get("bookkeepie_id");
    const { company_store, addCompanyInfo } = this.props;

    window.addEventListener("pagehide", this.handlePageHide);

    // Freeze the progress bar to whatever industry value exists right now, so it
    // doesn't shift while the user is still deciding on RegIndustrySelect itself.
    const initialProgressState = this.getRegProgressStateUpdate(this.state.activeStep);
    if (initialProgressState) {
      this.setState(initialProgressState);
    }

    if (
      company_store.utm_source ||
      company_store.utm_medium ||
      company_store.utm_campaign
    ) {
      this.setState({
        utm_source: company_store.utm_source || "",
        utm_medium: company_store.utm_medium || "",
        utm_campaign: company_store.utm_campaign || "",
        utm_content: company_store.utm_content || "",
        utm_term: company_store.utm_term || "",
        gclid: company_store.gclid || "",
        dclid: company_store.dclid || "",
      });
    }

    addCompanyInfo({
      id: "abVersion",
      data: "B",
      stateObject: "company_store",
    });

    // Mirrors searchFlowVersionB's NewCompanyType "reg" branch (persistLeadType) so a
    // visitor landing here directly — e.g. from a webflow page linking straight to
    // /company/request/reg — ends up with the same leadtype default as someone routed
    // here through that step. Reg has no fixed companytype default (RegTaxForm's own
    // pick), so nothing to set there.
    addCompanyInfo({
      id: "leadtype",
      data: "REG",
      stateObject: "company_store",
    });
    // REG requests are always for the "legal entity founding" service — set it
    // as soon as we know we're in this flow so the SearchSchema reflects it
    // while the user is still filling out the form, not only once the
    // AspRequest is submitted (see createAspRequest below for the same flag).
    // Also explicitly reset accounting/taxconsultingsimple/taxconsultingcomplex:
    // company_store is redux-persist'ed to localStorage, so a visitor who
    // abandoned e.g. the VAF flow earlier could otherwise land here with
    // taxconsultingsimple still true from that session, contaminating this
    // flow's services array.
    addCompanyInfo({
      id: "legalentityfounding",
      data: true,
      stateObject: "company_store",
    });
    addCompanyInfo({
      id: "taxconsultingsimple",
      data: false,
      stateObject: "company_store",
    });
    addCompanyInfo({
      id: "taxconsultingcomplex",
      data: false,
      stateObject: "company_store",
    });
    addCompanyInfo({
      id: "accounting",
      data: false,
      stateObject: "company_store",
    });
    // Also mirror it into company_store.services: updateSearchData() patches
    // `{...company_store}` wholesale on every step change, so if services stays
    // stale/empty in redux, that later full-object patch overwrites (wipes out)
    // the services array we're about to set on the search doc below.
    addCompanyInfo({
      id: "services",
      data: ["legalentityfounding"],
      stateObject: "company_store",
    });

    ensureSearchExists({
      flowType: "REG",
      abVersion: "B",
      company_store,
      addCompanyInfo,
      step: this.state.activeStep + 1,
      stepData: this.state.stepData,
    }).then((searchID) => {
      if (searchID) {
        this.setState({ searchID });
        this.startFlowAnalyticsSession();
        // SearchSchema has no standalone `legalentityfounding` field — services
        // only persist inside the `services` array (mirrors how the backend
        // builds AspRequest.services from the servicesText keys at submit time).
        axios
          .patch(
            `/api/search/${searchID}`,
            { services: ["legalentityfounding"] },
            { headers: { "Content-Type": "application/json" } },
          )
          .catch((error) => {
            console.error(
              "Error saving services to search:",
              error.response?.data || error.message,
            );
          });
      }
    });

    this.dataLayerUpdate(0, "sf_step_changed");
    this.dataLayerVersionUpdate();

    let cookie = document.cookie;
    if (!cookie.includes("reqsent")) {
      document.cookie = "reqsent=false";
    }

    if (!bkID) {
      bkID = uuidv4();
      this.setState({ bookkeepie_id: bkID });
      Cookies.set("bookkeepie_id", bkID, { expires: 90 });
      this.props.addCompanyInfo({
        id: "searchUser",
        data: bkID,
        stateObject: "company_store",
      });
      axios
        .post(
          `/api/searchUser`,
          {
            userID: bkID,
            searches: [],
            reqs: [],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          console.log("AXIOS RESPONSE: ", response);
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        });
    } else {
      this.props.addCompanyInfo({
        id: "searchUser",
        data: bkID,
        stateObject: "company_store",
      });
    }
    this.bkIdDataLayerUpdate(bkID, "sf_step_bookkeepie_id");

    const urlParams = new URLSearchParams(window.location.search);
    const urlCompanytype = urlParams.get("companytype");

    if (
      !company_store.companytype &&
      (urlCompanytype === "bt" || urlCompanytype === "kft")
    ) {
      this.props.addCompanyInfo({
        id: "anwser",
        data: "founding",
        stateObject: "company_store",
      });
      this.props.addCompanyInfo({
        id: "newlyfounded",
        data: true,
        stateObject: "company_store",
      });
      this.props.addCompanyInfo({
        id: "legalentityfounding",
        data: true,
        stateObject: "company_store",
      });
      this.props.addCompanyInfo({
        id: "companytype",
        data: urlCompanytype,
        stateObject: "company_store",
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener("pagehide", this.handlePageHide);
  }

  componentDidUpdate(_prevProps, prevState) {
    this.startFlowAnalyticsSession();
    this.handleSearchUpdate(prevState.activeStep);
    // Guard against re-running on every re-render (this component re-renders on
    // every company_store dispatch, e.g. each keystroke) — only sync once per
    // distinct searchID, not on every update.
    const searchID = this.state.searchID;
    if (!searchID || searchID === this.syncedSearchUserId) {
      return;
    }
    this.syncedSearchUserId = searchID;
    let bkID = Cookies.get("bookkeepie_id");
    if (bkID) {
      let searchList = [];
      axios
        .get(`/api/searchUser/${bkID}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          searchList = response.data.searchUser.searches.filter(
            (value) => value !== null,
          );
          const sid = this.state.searchID;
          const sidStr = sid && String(sid).trim();
          if (sidStr && !searchList.some((s) => String(s) === sidStr)) {
            searchList.push(sidStr);
            let uniques = [
              ...new Set(
                searchList.filter((item) => String(item).trim() !== ""),
              ),
            ];
            axios.patch(
              `/api/searchUser/${bkID}`,
              { searches: uniques },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              },
            );
          }
        })
        .catch((error) => {
          console.log(
            "AXIOS ERROR COMPUPDATE: ",
            error.response || error.message,
          );
        });
    }
  }

  getRegProgressStateUpdate = (stepIndex) => {
    const value = computeRegFlowProgressValue(this, stepIndex, STEPS);
    if (value === null) {
      return null;
    }
    return { regProgressValue: value, regProgressStep: stepIndex };
  };

  getEffectiveSearchId = () => {
    const id = this.state.searchID || this.props.company_store?.searchID;
    if (!id || id === "undefined" || id === "null") {
      return "";
    }
    return String(id);
  };

  /** entryFlow reflects the ORIGINAL entry into the funnel — frozen backend-side on
   * first write, so this only matters for a direct (non-handoff) landing on reg. */
  resolveEntryFlow = () => {
    const cs = this.props.company_store || {};
    return normalizeEntryFlowSlug(cs.flowStart || cs.leadtype || "reg");
  };

  initFlowAnalytics = () => {
    if (this.flowAnalytics) {
      return;
    }
    this.flowAnalytics = createRegFlowAnalytics({
      getSearchId: () => this.getEffectiveSearchId(),
      getSteps: () => STEPS,
      getFlowInstance: () => this,
      entryFlow: this.resolveEntryFlow(),
    });
  };

  /** Unlike searchFlowVersionB, reg has no value-prop gate — the funnel session
   * opens as soon as a searchID exists (own first step, or a resumed session). */
  startFlowAnalyticsSession = () => {
    if (this.analyticsSessionStarted) {
      return;
    }
    const searchId = this.getEffectiveSearchId();
    if (!searchId) {
      return;
    }
    this.initFlowAnalytics();
    this.analyticsSessionStarted = true;
    this.flowAnalytics.trackSessionStart(0);
    if (this.state.activeStep !== 0) {
      this.flowAnalytics.trackStepEnterCatchUp(this.state.activeStep);
    }
  };

  /** Safety net for terminal events fired before startFlowAnalyticsSession got a chance to run. */
  trackReqSentAnalytics = (reqId) => {
    if (!this.getEffectiveSearchId()) {
      return;
    }
    this.startFlowAnalyticsSession();
    if (!this.flowAnalytics) {
      return;
    }
    this.flowCompleteTracked = true;
    this.flowAnalytics.trackReqSent({ reqId, exitFlow: "reg" });
  };

  handlePageHide = () => {
    if (!this.flowCompleteTracked && this.analyticsSessionStarted) {
      this.flowAnalytics?.trackAbandonHint();
    }
  };

  handleNext = (increment = 1) => {
    if (typeof increment !== "number") increment = 1;
    if (this.state.activeStep < STEPS.length) {
      if (this.state.searchID === "") {
        this.submitSearchData();
      }
      const fromStep = this.state.activeStep;
      const nextStep = fromStep + increment;
      this.setState({
        activeStep: nextStep,
        ...(this.getRegProgressStateUpdate(nextStep) || {}),
      });
      this.dataLayerUpdate(nextStep, "sf_step_changed");
      if (this.state.completedSteps < this.state.activeStep) {
        this.setState({
          completedSteps: this.state.completedSteps + increment,
        });
      }
      if (this.analyticsSessionStarted && this.flowAnalytics) {
        this.flowAnalytics.trackNavigation({
          fromStepIndex: fromStep,
          toStepIndex: nextStep,
          direction: "forward",
        });
      }
    }
    this.props.addCompanyInfo({
      id: "isCommission",
      data: true,
      stateObject: "company_store",
    });
    this.props.addCompanyInfo({
      id: "activeStep",
      data: this.state.activeStep,
      stateObject: "company_store",
    });
    window.scrollTo(0, 0);
  };
  handleBack = (decr = 1) => {
    if (typeof decr !== "number") decr = 1;
    if (this.state.activeStep !== 0) {
      const fromStep = this.state.activeStep;
      const prevStep = fromStep - decr;
      this.setState({
        activeStep: prevStep,
        ...(this.getRegProgressStateUpdate(prevStep) || {}),
      });
      if (this.analyticsSessionStarted && this.flowAnalytics) {
        this.flowAnalytics.trackNavigation({
          fromStepIndex: fromStep,
          toStepIndex: prevStep,
          direction: "back",
        });
      }
    }
    this.props.addCompanyInfo({
      id: "activeStep",
      data: this.state.activeStep,
      stateObject: "company_store",
    });
    window.scrollTo(0, 0);
  };
  handleTracker = (step) => {
    this.setState({ activeStep: step });
  };
  handleKnetPlusContact = () => {
    this.setState({ kNetPlusSent: true });
  };
  openHelpForm = () => {
    this.setState({ helpForm: true });
  };
  closeHelpForm = () => {
    this.setState({ helpForm: false });
  };
  // Navigation helpers
  goTo = (target) => {
    const from = STEPS[this.state.activeStep]?.component;
    this.handleNext(getStepIncrement(from, target));
  };

  goBack = (target) => {
    const from = STEPS[this.state.activeStep]?.component;
    this.handleBack(getStepIncrement(target, from));
  };

  regIndustryShowsActivityStep = () =>
    regIndustryHasActivityContent(this.props.company_store?.industry);

  regIndustryShowsForeignTradeStep = () =>
    evIndustryHasForeignTradeStep(this.props.company_store?.industry);

  resolveRegIndustryActivityNextStep = () =>
    this.state.regEntrySource === "companytype" ? RegCompanyType : RegActivityDescription;

  handleRegIndustrySelectBack = () => {
    if (this.analyticsSessionStarted && this.flowAnalytics) {
      this.flowCompleteTracked = true;
      this.flowAnalytics.trackFlowHandoff({ exitFlow: "asp" });
    }
    const searchID = this.state.searchID || this.props.company_store?.searchID;
    const searchIDParam = searchID ? `&searchID=${searchID}` : "";
    window.location.assign(`/company/request/1?resumeStep=newCompanyType${searchIDParam}`);
  };

  handleRegIndustrySelectNext = () => {
    if (this.regIndustryShowsActivityStep()) {
      this.goTo(RegIndustryActivity);
    } else {
      this.goTo(this.resolveRegIndustryActivityNextStep());
    }
  };

  handleRegIndustryActivityBack = () => this.goBack(RegIndustrySelect);
  handleRegIndustryActivityNext = () =>
    this.goTo(this.resolveRegIndustryActivityNextStep());

  setRegCompanyTypeSelection = (value) => {
    this.setState({ regCompanyTypeSelection: value, regTaxFormInteracted: false });
  };

  handleRegCompanyTypeBack = () => {
    if (this.regIndustryShowsActivityStep()) {
      this.goBack(RegIndustryActivity);
      return;
    }
    this.goBack(RegIndustrySelect);
  };

  handleRegCompanyTypeNext = () => {
    const target = this.state.regCompanyTypeSelection;
    // Carry the existing searchID across this hard navigation (company_store
    // doesn't survive a full page load) so the destination flow's
    // ensureSearchExists() resumes this same search instead of creating a new one.
    const searchID = this.state.searchID || this.props.company_store?.searchID;
    const searchIDParam = searchID ? `?searchID=${searchID}` : "";
    if (target === "vaf") {
      if (this.analyticsSessionStarted && this.flowAnalytics) {
        this.flowCompleteTracked = true;
        this.flowAnalytics.trackFlowHandoff({ exitFlow: "vaf" });
      }
      window.location.assign(`/company/request/vafb${searchIDParam}`);
      return;
    }
    if (target === "kftreg") {
      if (this.analyticsSessionStarted && this.flowAnalytics) {
        this.flowCompleteTracked = true;
        this.flowAnalytics.trackFlowHandoff({ exitFlow: "kftreg" });
      }
      window.location.assign(`/company/request/kftregb${searchIDParam}`);
      return;
    }
    this.goTo(RegActivityDescription);
  };

  handleRegActivityDescriptionBack = () => {
    // Mirrors resolveRegIndustryActivityNextStep()'s forward-direction branch —
    // arriving here via RegCompanyType (regEntrySource === "companytype") must
    // also leave via RegCompanyType, otherwise Back skips it entirely.
    if (this.state.regEntrySource === "companytype") {
      this.goBack(RegCompanyType);
      return;
    }
    if (this.regIndustryShowsActivityStep()) {
      this.goBack(RegIndustryActivity);
      return;
    }
    this.goBack(RegIndustrySelect);
  };
  handleRegActivityDescriptionNext = () => this.goTo(RegTaxForm);

  handleRegTaxFormBack = () => this.goBack(RegActivityDescription);
  handleRegTaxFormNext = () => {
    if (this.regIndustryShowsForeignTradeStep()) {
      this.goTo(RegForeignTrade);
    } else {
      this.goTo(RegContactPage);
    }
  };
  /** Frontend-only guard: Next stays disabled until the user picks on this screen, even if companytype already has a stored default. */
  handleRegTaxFormInteractedChange = (hasInteracted) => {
    if (this.state.regTaxFormInteracted !== hasInteracted) {
      this.setState({ regTaxFormInteracted: hasInteracted });
    }
  };

  handleRegForeignTradeBack = () => this.goBack(RegTaxForm);
  handleRegForeignTradeNext = () => this.goTo(RegContactPage);

  /** Shown when the ASP request fails to send from the contact page (no reqID / network error). */
  handleContactPageRequestError = () => this.goTo(GeneralError);

  setIndustrySelection = (industry) =>
    persistIndustryWithFinancialDefaults({
      industry,
      searchID: this.state.searchID || this.props.company_store?.searchID,
      addCompanyInfo: this.props.addCompanyInfo,
      clearIndustryInputWhenNotOther: true,
    }).catch((error) => {
      console.error(
        "Error saving industry financial defaults to searchSchema:",
        error.response?.data || error.message,
      );
      throw error;
    });

  setIndustryInput = (value) => {
    this.props.addCompanyInfo({
      id: "industryinput",
      data: value,
      stateObject: "company_store",
    });
  };

  createAspRequest = (companyData) => {
    let data = prepareAspPayload(companyData, {
      searchID:
        this.state.searchID ||
        this.props.company_store?.searchID ||
        companyData.searchID ||
        "",
      abVersion: this.props.company_store.abVersion || "B",
    });
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    if (data.incominginvoices === "") {
      data.incominginvoices = 0;
    }
    if (data.outgoinginvoices === "") {
      data.outgoinginvoices = 0;
    }
    // REG requests are always for the "legal entity founding" service (mirrors
    // vafFlowVersionB's taxconsultingsimple) so it lands in the AspRequest's and
    // the SearchSchema's services array on the backend.
    data.legalentityfounding = true;
    // reg submissions set callbacksource (see RegistrationContactPage.jsx) to route
    // through the callback endpoint, which is what triggers the flow-specific customer
    // email ("Company - REG RFP Details") and the internal "REG igénylés" notification —
    // the plain /api/aspreq endpoint only ever sends the generic ASP accountant-matching emails.
    const endpoint = data.callbacksource
      ? "/api/aspreq/requestcallback/new"
      : "/api/aspreq";
    return axios
      .post(endpoint, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        sessionStorage.setItem("reqEmail", data.email);
        const reqID = response.data.result._id;
        const searchID = response.data.searchID || this.state.searchID;

        console.log("ASP Request created successfully:", {
          reqID: reqID,
          searchID: searchID,
          backendSearchID: response.data.searchID,
          existingSearchID: this.state.searchID,
        });

        return new Promise((resolve, reject) => {
          try {
            this.setState({ reqID: reqID }, () => {
              this.props.addCompanyInfo({
                id: "reqID",
                data: reqID,
                stateObject: "company_store",
              });

              const finish = () => {
                this.handleSearchRequestSent(reqID);
                resolve(response);
              };

              if (response.data.searchID && !this.state.searchID) {
                this.setState({ searchID: response.data.searchID }, () => {
                  this.props.addCompanyInfo({
                    id: "searchID",
                    data: response.data.searchID,
                    stateObject: "company_store",
                  });
                  finish();
                });
              } else {
                finish();
              }
            });
          } catch (err) {
            reject(err);
          }
        });
      })
      .catch((error) => {
        console.error("Failed to create ASP request:", {
          error: error.response?.data || error.message,
          searchID: this.state.searchID,
          email: data.email,
        });
        throw error;
      });
  };

  createCherryRequest = (companyData) => {
    let data = Object.assign({}, companyData);
    let ppArray = [];
    for (var i in data.potential_providers) {
      ppArray.push(data.potential_providers[i]);
    }
    data.potential_providers = ppArray;
    data.searchID =
      this.state.searchID ||
      this.props.company_store?.searchID ||
      data.searchID ||
      "";
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    if (data.incominginvoices === "") {
      data.incominginvoices = 0;
    }
    if (data.outgoinginvoices === "") {
      data.outgoinginvoices = 0;
    }

    axios
      .post(`/api/request`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const reqID = response.data.result._id;
        const cherryID = reqID;
        const searchID = response.data.searchID || this.state.searchID;

        console.log("Cherry Request created successfully:", {
          reqID: reqID,
          cherryID: cherryID,
          searchID: searchID,
          backendSearchID: response.data.searchID,
          existingSearchID: this.state.searchID,
        });

        this.setState({ cherryID: cherryID }, () => {
          this.props.addCompanyInfo({
            id: "cherryID",
            data: cherryID,
            stateObject: "company_store",
          });

          if (this.state.reqID === "" || !this.state.reqID) {
            this.setState({ reqID: reqID }, () => {
              this.props.addCompanyInfo({
                id: "reqID",
                data: reqID,
                stateObject: "company_store",
              });

              // Update searchID if backend created/returned one
              if (response.data.searchID && !this.state.searchID) {
                this.setState({ searchID: response.data.searchID }, () => {
                  this.props.addCompanyInfo({
                    id: "searchID",
                    data: response.data.searchID,
                    stateObject: "company_store",
                  });
                  this.handleSearchRequestSent(reqID);
                });
              } else {
                this.handleSearchRequestSent(reqID);
              }
            });
          } else {
            // Update searchID if backend created/returned one
            if (response.data.searchID && !this.state.searchID) {
              this.setState({ searchID: response.data.searchID }, () => {
                this.props.addCompanyInfo({
                  id: "searchID",
                  data: response.data.searchID,
                  stateObject: "company_store",
                });
                this.handleSearchRequestSent(reqID);
              });
            } else {
              this.handleSearchRequestSent(reqID);
            }
          }
        });
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error);
      });
  };
  updateRequest = (companyData, reqID = this.state.reqID) => {
    let data = Object.assign({}, companyData);
    if (data.potential_providers) {
      delete data.potential_providers;
    }
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    let dataToSend = { reqData: data, reqID: reqID };
    axios
      .patch(`/api/request/addprov`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };
  updateFakeCherryRequest = (companyData) => {
    let data = Object.assign({}, companyData);
    if (data.noofemployees === "") {
      data.noofemployees = 0;
    }
    let dataToSend = { reqData: data, reqID: this.state.reqID };
    axios
      .patch(`/api/aspreq/addprov/addfakecherry`, dataToSend, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };

  handleSearchRequestSent = (reqID = null) => {
    const timeStamp = this.state.stepData.concat(
      ` Req sent - ${new Date().toLocaleTimeString(
        i18n.t("general.countryformat"),
        {
          hour12: false,
        },
      )}`,
    );
    const actualReqID = reqID || this.state.reqID;
    this.trackReqSentAnalytics(actualReqID);
    this.setState({ stepData: timeStamp }, () =>
      this.updateSearchData(timeStamp, actualReqID),
    );
    // Backend already updates rfpsent and reqID, no need for frontend update
  };

  submitSearchData = () => {
    const cs = this.props.company_store;
    if (!this.state.searchID && cs.searchID) {
      this.setState({ searchID: cs.searchID });
      return;
    }
    if (!this.state.searchID && !cs.searchID) {
      ensureSearchExists({
        flowType: "REG",
        abVersion: "B",
        company_store: cs,
        addCompanyInfo: this.props.addCompanyInfo,
        step: this.state.activeStep + 1,
        stepData: this.state.stepData,
      }).then((searchID) => {
        if (searchID) this.setState({ searchID });
      });
      return;
    }

    let data = { ...cs };
    data.step = this.state.activeStep + 1;
    data.time = this.state.stepData;
    data.returnedProviders = 0;
    data.screenWidth = `${window.innerWidth}`;
    data.lang = cs.chosenLanguage;
    data.leadtype = "REG";
    data.flowStart = cs.flowStart || "REG";
    mergeUtmIntoPayload(
      data,
      this.state,
      resolveUtmParams({ company_store: cs, componentState: this.state }),
    );
    data.abVersion = cs.abVersion || "B";

    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      effectiveSearchID &&
      effectiveSearchID !== "undefined" &&
      effectiveSearchID !== "null"
    ) {
      axios
        .patch(
          `/api/search/${effectiveSearchID}`,
          {
            leadtype: "REG",
            flowStart: cs.flowStart || "REG",
            abVersion: cs.abVersion || "B",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          console.log("Search updated: ", response.statusText);
        })
        .catch((error) => {
          console.log("AXIOS ERROR updating search: ", error.response.data);
        });
    } else {
      axios
        .post(`/api/search`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("AXIOS RESPONSE: ", response.statusText);
          this.setState({ searchID: response.data.result._id });
          response.data.result._id &&
            this.props.addCompanyInfo({
              id: "searchID",
              data: response.data.result._id,
              stateObject: "company_store",
            });
        })
        .catch((error) => {
          console.log("AXIOS ERROR: ", error.response.data);
        });
    }
  };
  updateSearchData = (time, reqID = null) => {
    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (
      !effectiveSearchID ||
      effectiveSearchID === "undefined" ||
      effectiveSearchID === "null"
    ) {
      return;
    }

    let data = { ...this.props.company_store };
    const timeValue = time ?? this.state.stepData;
    data.lang = this.props.company_store.chosenLanguage;
    if (!this.state.requestSent) {
      data.step = this.state.activeStep + 1;
    }
    data.time = timeValue;
    // Only include reqID if we have a valid value (backend will set it anyway)
    // Don't send empty string which might overwrite backend value
    const actualReqID = reqID || this.state.reqID;
    if (
      actualReqID &&
      actualReqID !== "" &&
      actualReqID !== null &&
      actualReqID !== undefined
    ) {
      data.reqID = actualReqID;
    }
    data.abVersion = this.props.company_store.abVersion || "B";
    mergeUtmIntoPayload(
      data,
      this.state,
      resolveUtmParams({
        company_store: this.props.company_store,
        componentState: this.state,
      }),
    );
    data.distanceWeight = this.props.store.match_score_weights.distanceWeight;
    data.priceWeight = this.props.store.match_score_weights.priceWeight;
    data.reviewWeight = this.props.store.match_score_weights.reviewWeight;
    data.phoneWeight = this.props.store.match_score_weights.phoneWeight;
    data.availabilityWeight =
      this.props.store.match_score_weights.availabilityWeight;
    data.experienceWeight =
      this.props.store.match_score_weights.experienceWeight;
    data.liabilityInsWeight =
      this.props.store.match_score_weights.liabilityInsWeight;
    data.badgeWeight = this.props.store.match_score_weights.badgeWeight;
    if (
      this.props.potential_providers !== undefined &&
      this.props.potential_providers.constructor === Object &&
      this.props.potential_providers.some((e) => e.length !== 0)
    ) {
      let rPCounter = 0;
      this.props.potential_providers.forEach((e) => {
        console.log(e, "EEEEE");
        rPCounter += e.length;
      });

      data.returnedProviders = rPCounter;
      let tempArray = [[], [], []];
      for (let i in this.props.potential_providers) {
        for (let j in i) {
          tempArray[i].push(this.props.potential_providers[i][j].companyname);
        }
      }
      data.providers = tempArray;
    }
    axios
      .patch(`/api/search/${effectiveSearchID}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };
  handleSearchUpdate = (prevStep) => {
    if (this.state.activeStep !== prevStep) {
      let timeString = this.state.stepData.concat(
        `, ${this.state.activeStep + 1} - ${new Date().toLocaleTimeString(
          "hu-HU",
          {
            hour12: false,
          },
        )}`,
      );
      this.setState({
        stepData: timeString,
      });
      if (this.state.activeStep !== 0) {
        this.updateSearchData(timeString);
      }
    }
    if (prevStep === "tableUpdate") {
      this.updateSearchData(this.state.stepData);
    }
  };
  updateViewedProviders = (provider) => {
    let data = {};
    let viewedProviders = this.state.viewedProviders;
    if (viewedProviders.length === 0) {
      viewedProviders.push(provider);
    }
    if (
      viewedProviders.length > 0 &&
      !viewedProviders.some((item) => item.name === provider.name)
    ) {
      viewedProviders.push(provider);
    }
    data.viewedProviders = viewedProviders;
    this.setState({
      viewedProviders: viewedProviders,
    });
    const effectiveSearchID =
      this.state.searchID || this.props.company_store?.searchID;
    if (!effectiveSearchID) return;
    axios
      .patch(`/api/search/${effectiveSearchID}`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("AXIOS RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("AXIOS ERROR: ", error.response.data);
      });
  };

  renderStep = () => {
    const stepConfig = STEPS[this.state.activeStep];
    if (!stepConfig || !stepConfig.component) return i18n.t("general.notfound");
    const StepComponent = stepConfig.component;
    const commonProps = {
      handleNext: this.handleNext,
      handleBack: this.handleBack,
      openHelpForm: this.openHelpForm,
    };
    const extra = stepConfig.extraProps ? stepConfig.extraProps(this) : {};
    return <StepComponent {...commonProps} {...extra} />;
  };

  render() {
    const footerNav = getRegStepFooterNav(this, this.state.activeStep, STEPS);
    const progress = getRegFlowProgress(this, this.state.activeStep, STEPS);
    return (
      <>
        <VacationNotice />
        <div className={`${classes.container} ${classes.routingContainer}`}>
          <SearchFlowHeader hideContinueLater />
          <Dialog
            open={this.props.company_store.idk || this.state.helpForm}
            onClose={() => {
              this.props.company_store.idk === true
                ? this.props.addCompanyInfo({
                    id: "idk",
                    data: false,
                    stateObject: "company_store",
                  })
                : this.setState({ helpForm: false });
            }}
            handleClose={() => {
              this.props.company_store.idk === true
                ? this.props.addCompanyInfo({
                    id: "idk",
                    data: false,
                    stateObject: "company_store",
                  })
                : this.setState({ helpForm: false });
            }}
          >
            <KnetPlusForm
              kNetPlusSent={this.state.kNetPlusSent}
              handleKnetPlusContact={this.handleKnetPlusContact}
              closeHelpForm={this.closeHelpForm}
              helpForm={this.state.helpForm}
            />
          </Dialog>
          <div className={classes.stepContent}>{this.renderStep()}</div>
          <SearchFlowFooterShell footerNav={footerNav} progress={progress} />
          {ENABLE_REG_FLOW_MONITORS && <Monitors />}
          <div style={{ display: "none" }}>
            <p>Hidden fields</p>
            <input type="hidden" />
            <br />
            <input type="text" id="utm_source" name="utm_source" />
            <br />
            <input type="text" id="utm_medium" name="utm_medium" />
            <br />
            <input type="text" id="utm_campaign" name="utm_campaign" />
            <br />
            <input type="text" id="utm_content" name="utm_content" />
            <br />
            <input type="text" id="utm_term" name="utm_term" />
            <br />
            <input type="text" id="gclid" name="gclid" />
            <br />
            <input type="text" id="dclid" name="dclid" />
            <br />
          </div>
        </div>
      </>
    );
  }
}

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(RegFlowVersionB),
);
